import React, { useState } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import icon_img from "../../images/logo.png";
import { fontSize } from "../../styles";
import { loginUser } from "../../service/logic";
import { useWindowDimensions, OpeningLayout } from "../common";

const useStyles = makeStyles((theme) => ({
  logo: {
    width: 330,
    [theme.breakpoints.down("sm")]: {
      width: 250,
    },
    [theme.breakpoints.down("xs")]: {
      width: "55%",
    },
  },
  paper: {
    height: "100vh",
    width: "50%",
    [theme.breakpoints.down("sm")]: {
      width: "60%",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      padding: "50px 10px",
    },
    padding: 50,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    zIndex: 1,
  },
  form: {
    width: "90%",
    color: "#1D3557",
  },
  inputfield: {
    color: "#1D3557",
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: `0px solid white`,
      },
      "&.Mui-focused fieldset": {
        border: `0px solid white`,
      },
    },
  },
  input: {
    color: "#1D3557",
    "&:hover": {
      color: "#457B9D",
    },
  },
  placeholderColor: {
    "&::placeholder": {
      color: "black",
      fontWeight: "bold",
    },
  },
  buttonContainer: {
    [theme.breakpoints.down("xs")]: {
      display: "flex",
      width: "100%",
    },
    textAlign: "center",
  },
  submit: {
    paddingLeft: 75,
    paddingRight: 75,
    backgroundColor: "#1D3557",
    borderRadius: 16,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    fontSize: fontSize.h4,
    "&:hover": {
      backgroundColor: "#457B9D",
    },
    [theme.breakpoints.down("xs")]: {
      paddingLeft: 55,
      paddingRight: 55,
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
  },
  linkdiv: {
    textAlign: "center",
  },
  links: {
    marginTop: 20,
    marginBottom: 20,
    [theme.breakpoints.down("xs")]: {
      justifyContent: "flex-start",
    },
    width: "100%",
    display: "flex",
  },
  linktext: {
    color: "red",
    textDecoration: "underline",
  },
  errorStyle: {
    color: "red",
    marginBottom: 10,
  },
  betweenLink: {
    width: 10,
    marginLeft: 20,
    marginRight: 20,
    justifyContent: "center",
    justifyItems: "center",
    justify: "center",
  },
  verticalLine: {
    width: 2,
    height: 24,
    backgroundColor: "#000",
    justifyContent: "center",
    fontSize: 30,
    marginLeft: 4,
    marginRight: 4,
  },
  imageHolder: {
    [theme.breakpoints.down("xs")]: {
      justifyContent: "flex-start",
    },
    display: "flex",
    width: "100%",
    justifyContent: "center",
    marginTop: 50,
    marginBottom: 50,
  },
}));

export default function LoginScreen() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const onLogin = async (event) => {
    event.preventDefault();

    const result = await loginUser({
      email,
      password,
    });

    if (result && !result.accessToken) {
      setErrorMessage(result);
    }
  };

  const classes = useStyles();
  const { height, width } = useWindowDimensions();
  const isIpad = width / height === 768 / 1024;
  const isIpadPro = width / height === 1024 / 1366;

  return (
    <React.Fragment>
      <CssBaseline />
      <OpeningLayout
        content={
          <div
            className={classes.paper}
            style={{
              justifyContent: isIpadPro || isIpad ? "center" : "flex-start",
            }}
          >
            <div className={classes.imageHolder}>
              <img
                className={classes.logo}
                src={icon_img}
                alt={"Virtual Patient"}
              />
            </div>
            <form className={classes.form} noValidate>
              <TextField
                className={classes.inputfield}
                margin="normal"
                fullWidth
                id="email"
                placeholder="Email"
                name="email"
                onChange={(event) => {
                  setEmail(event.target.value);
                }}
                InputProps={{
                  className: classes.input,
                  classes: { input: classes.placeholderColor },
                }}
              />
              <TextField
                className={classes.inputfield}
                margin="normal"
                fullWidth
                name="password"
                placeholder="Password"
                type="password"
                id="password"
                autoComplete="current-password"
                onChange={(event) => {
                  setPassword(event.target.value);
                }}
                InputProps={{
                  className: classes.input,
                  classes: { input: classes.placeholderColor },
                }}
              />
              <Typography className={classes.errorStyle}>
                {errorMessage}
              </Typography>
              <div className={classes.buttonContainer}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  onClick={onLogin}
                >
                  Login
                </Button>
              </div>
              <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
                className={classes.links}
              >
                <Link href="/forgetpassword">
                  <Typography className={classes.linktext}>
                    {"Forgot Password"}
                  </Typography>
                </Link>
                <div className={classes.betweenLink}>
                  <div className={classes.verticalLine}></div>
                </div>
                <Link href="/register">
                  <Typography className={classes.linktext}>
                    {"Register"}
                  </Typography>
                </Link>
              </Grid>
            </form>
          </div>
        }
      />
    </React.Fragment>
  );
}
